import apiFetch from '../../apiFetch'

export default function (token, processingAgencyId, filter, typeId) {
  return apiFetch({ endPoint: `ProcessingAgency/${processingAgencyId}/DocTypeUses/List/${typeId}`, method: 'POST', body: filter, token: token })
}
